// Atlas AppBench navigation is maintained by Hammerhead Technologies Inc.

import type { AppBenchNavigationItem } from '@audio-collection/shared';

export interface AppBenchNavigationDefinition {
  id: AppBenchNavigationItem;
  label: string;
  path: string;
}

export const APPBENCH_TENANT_NAVIGATION: readonly AppBenchNavigationDefinition[] = [
  { id: 'dashboard', label: 'Dashboard', path: '/admin/appbench/dashboard' },
  { id: 'datasets', label: 'Datasets', path: '/admin/appbench/datasets' },
  { id: 'connections', label: 'Models', path: '/admin/appbench/connections' },
  { id: 'apps', label: 'Connectors', path: '/admin/appbench/apps' },
  { id: 'benchmarks', label: 'Benchmarks', path: '/admin/appbench/benchmarks' },
  { id: 'runs', label: 'Runs', path: '/admin/appbench/runs' },
  { id: 'live-monitor', label: 'Live Monitor', path: '/admin/appbench/live-monitor' },
  { id: 'reports', label: 'Reports', path: '/admin/appbench/reports' },
  { id: 'usage-budgets', label: 'Usage & Budgets', path: '/admin/appbench/usage-budgets' },
  { id: 'settings-audit', label: 'Settings & Audit', path: '/admin/appbench/settings-audit' },
] as const;
